import propTypes from 'prop-types';
import { useTheme } from 'styled-components';

const SvgCloseDoorIcon = ({ size, color, ...props }) => {
  const theme = useTheme();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 212 332"
      fill={theme.colors[color] || color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 324C0 319.582 3.58172 316 8 316H204C208.418 316 212 319.582 212 324C212 328.418 208.418 332 204 332H7.99999C3.58172 332 0 328.418 0 324Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 0C23.1634 0 16 7.16345 16 16V284C16 292.837 23.1634 300 32 300H180C188.837 300 196 292.837 196 284V16C196 7.16344 188.837 0 180 0H32ZM48 166C56.8366 166 64 158.837 64 150C64 141.163 56.8366 134 48 134C39.1634 134 32 141.163 32 150C32 158.837 39.1634 166 48 166Z"
        fill="inherit"
      />
    </svg>
  );
};

export default SvgCloseDoorIcon;

SvgCloseDoorIcon.propTypes = {
  size: propTypes.string,
  color: propTypes.string,
};

SvgCloseDoorIcon.defaultProps = {
  size: '16px',
  color: 'highBlack',
};
